export const formatInputName = (name: string): string => name.replace(/ /g, '-')
export const formatOptInputName = (
  name: string,
  radioValue: { value: string }
) => `${name}-${radioValue.value.replace(/ /g, '-')}`
